function loadMoreBlogs(blogType, loadMore) {
	var blogOffset;
	if (loadMore) {
		blogOffset = getBlogOffsetValue();
	} else {
		blogOffset = parseInt(0);
	}
	$.ajax({
		url: "/blog/fetch-blogs/" + blogType,
		data: { offset: blogOffset },
		type: 'GET',
		success: (data) => {
			$('#blogOffset').remove(); // Remove existing blogOffSet element
			if (loadMore) {
				$(".blog-list-container").append(data);
			} else {
				$(".blog-list-container").empty();
				$(".blog-list-container").append(data);
				var activeBlogType = $("#activeBlogType").text(); // Update the "Load More" button's onClick event when switching between blog types.
				$("#loadMoreBlogs").attr("onclick", "loadMoreBlogs('" + activeBlogType + "', true)")
			}
			$('#activeBlogType').remove(); // Remove existing activeBlogType span element
			var blogCount = parseInt($("#blogCount").html());
			blogOffset = getBlogOffsetValue();
			if (blogCount <= blogOffset) { // Hide the "Load More" button if there are no more blogs.
				$("#loadMoreBlogs").hide();
			} else {
				$("#loadMoreBlogs").show();
			}
		},
	});
}

function getBlogOffsetValue() {
	var blogOffsetSpan = $("#blogOffset").html();
	return blogOffset = parseInt(blogOffsetSpan);
}

/*Dropdown Menu*/
$('.dropdown').click(function() {
	$(this).attr('tabindex', 1).focus();
	$(this).toggleClass('active');
	$(this).find('.dropdown-menu').slideToggle(300);
});
$('.dropdown').focusout(function() {
	$(this).removeClass('active');
	$(this).find('.dropdown-menu').slideUp(300);
});
$('.dropdown .dropdown-menu li').click(function() {
	$(this).parents('.dropdown').find('span').text($(this).text());
	$(this).parents('.dropdown').find('input').attr('value', $(this).attr('id'));
});
/*End Dropdown Menu*/


$('.dropdown-menu li').click(function() {
	var blogType = $(this).parents('.dropdown').find('input').val();
	loadMoreBlogs(blogType, false);
	var newUrl = "/en";
	if (blogType === "Customers") {
		newUrl = newUrl + '/blog';
	} else if (blogType === "Partners") {
		newUrl = newUrl + '/blog-partner';
	}
	window.history.pushState({}, '', newUrl);
}); 